import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { useUtmify } from './hooks/useUtmify';
export function App() {
  // Inject UTMify tracking script into <head>
  useUtmify();
  return <LandingPage data-id="element-0" />;
}